// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2y2Bw","header":"Messages_header__2Vvc7"};